export default __webpack_public_path__ + "static/media/icon_Okchain.21634370.svg";